import { render, staticRenderFns } from "./SwitchAvailability.vue?vue&type=template&id=2d8870fc&scoped=true"
import script from "./switchAvailability.ts?vue&type=script&lang=ts&external"
export * from "./switchAvailability.ts?vue&type=script&lang=ts&external"
import style0 from "./SwitchAvailability.vue?vue&type=style&index=0&id=2d8870fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8870fc",
  null
  
)

export default component.exports